import { render, staticRenderFns } from "./OptionsCard.vue?vue&type=template&id=528fcfaa&scoped=true"
import script from "./OptionsCard.vue?vue&type=script&lang=js"
export * from "./OptionsCard.vue?vue&type=script&lang=js"
import style0 from "./OptionsCard.vue?vue&type=style&index=0&id=528fcfaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528fcfaa",
  null
  
)

export default component.exports